import React, { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

const KEY = "kasir_cart";

function loadInitial() {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) return JSON.parse(raw);
  } catch {}
  return { items: [], tableNumber: "" };
}

export function CartProvider({ children }) {
  const initial = loadInitial();
  const [tableNumber, setTableNumber] = useState(initial.tableNumber || "");
  const [items, setItems] = useState(initial.items || []);

  useEffect(() => {
    localStorage.setItem(KEY, JSON.stringify({ items, tableNumber }));
  }, [items, tableNumber]);

  const addItem = (item) => setItems((prev) => [...prev, { ...item, cart_id: Date.now() + Math.random() }]);
  const removeItem = (cart_id) => setItems((prev) => prev.filter((i) => i.cart_id !== cart_id));
  const updateQty = (cart_id, qty) =>
    setItems((prev) => prev.map((i) => (i.cart_id === cart_id ? { ...i, quantity: Math.max(1, qty) } : i)));
  const clear = () => setItems([]);

  const subtotal = items.reduce((sum, it) => {
    const opt = (it.options || []).reduce((a, o) => a + (o.price_delta || 0), 0);
    return sum + (it.unit_price + opt) * it.quantity;
  }, 0);

  const totalCount = items.reduce((a, i) => a + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, addItem, removeItem, updateQty, clear, subtotal, totalCount, tableNumber, setTableNumber }}>
      {children}
    </CartContext.Provider>
  );
}

export const useCart = () => useContext(CartContext);
